import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { zeroWidthNonBreakingSpace } from '@upright/ui/common/generic/utilities/zero-width-space';
import styled from 'styled-components';
import { useCarouselLayout } from '../../../../impact-lens-profile/context';

export function BackLine() {
  const layout = useCarouselLayout();
  const area = layout.aggregateResultArea();
  const style = {
    left: area.cx,
    width: 1,
    top: 0,
    // top: area.y1,
  };
  return <LineRoot style={style}>{zeroWidthNonBreakingSpace}</LineRoot>;
}

const LineRoot = styled.div`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
`;
